<section id="form">
  <form [formGroup]="formulario" class="form container bg-color-light-grey color-dark"
    (ngSubmit)="onSubimitFormulario()">
    <h2 class="form-title text-center">
      Consulta Pública<br>
      Carga horária mínima presencial para cursos técnicos
    </h2>

    <div class="form-group">
      <label class="form-label">
        Nome*:
        <app-required-text formControlName="nome" name="nome"></app-required-text>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        E-mail*:
        <app-required-text formControlName="email" name="email" id="email"></app-required-text>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Instituição/Empresa:
        <input type="text" class="form-control" formControlName="instituicaoEmpresa" />
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Sua sugestão é para*:
        <select class="form-control select" formControlName="sugestaoPara">
          <option value="Alteração de carga horária mínima presencial" selected>
            Alteração de carga horária mínima presencial para um curso técnico
          </option>
        </select>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label">
        Eixo tecnológico*:
        <select formControlName="eixoTecnologicoCnctId" class="form-control select" id="eixo">
          <option *ngFor="let eixo of eixos" [ngValue]="eixo.id">{{ eixo.nome }}</option>
        </select>
      </label>
      <ng-container *ngIf="
            !formulario.get('eixoTecnologicoCnctId').valid &&
            formulario.get('eixoTecnologicoCnctId').touched
          ">
        <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
      </ng-container>
    </div>

    <div class="form-group">
      <label class="form-label">
        Curso*:
        <select formControlName="cursoCnctId" class="form-control select" id="cursos">
          <option *ngFor="let curso of cursos" [ngValue]="curso.id">{{ curso.nome }}</option>
        </select>
      </label>
    </div>

    <div class="form-group form-eixo">
      <app-custom-form [enviouForm]="enviouFormulario" [display]="true"
        (alterouValorProposta)="formulario.get('propostaCargaHoraria').setValue($event)"
        (alterouValorJustificativa)="formulario.get('justificativaCargaHoraria').setValue($event)"></app-custom-form>
    </div>

    <div class="form-checkbox form-group">
      <input id="termo" type="checkbox" class="input-checkbox" formControlName="aceitaTermo" />
      <label class="label-checkbox" for="termo">
        Autorizo o Ministério da Educação e a equipe responsável pela atualização dos Catálogos Nacionais
        de Cursos a entrarem em contato comigo pelo endereço de e-mail informado neste formulário para tirar
        dúvidas e complementar informações.
      </label>
    </div>

    <div class="recaptcha">
      <re-captcha formControlName="reCaptcha" siteKey="6LfndeMcAAAAAPSpZjo6cC9PLyKLBKbZ2FJSyuIM"></re-captcha>
    </div>

    <div class="wrapper">
      <button class="btn btn-md rounded-pill btn-dark cursor-pointer" [ngClass]="{ shake: formErro }" id="botao-form"
        role="button">
        Enviar
      </button>
    </div>

    <app-popup [tipoFormulario]="'sugestao'" [resposta]="resposta" [mostrarPopUp]="mostarPopUp" (cancel)="cancelar()"
      (submit)="onSubimitFormulario()" [erro]="erro"></app-popup>
  </form>
</section>